import { C50TopStatisticsItemProps } from './C50TopStatisticsItem.types';
import { TopStatisticsItemProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function CreateTopStatisticsItemModel(
  props?: C50TopStatisticsItemProps
): TopStatisticsItemProps {
  const { fields } = props || {};
  const { renderRichText, renderText } = useConditionalRendering();
  return {
    topStatistic: renderText(fields?.TopStatistic),
    supportCopy: renderRichText(fields?.SupportCopy),
  };
}
